<template>
  <div>
    <a
      :href="href"
      @click="onClick($event)"
      :aria-label="ariaLabel"
      v-bind="$attrs"
      :class="cssClass"
    >
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  props: ['href', 'ariaLabel'],
  data() {
    return {
      cssClass: '',
    };
  },
  mounted() {
    const classes = this.$el.classList.value;
    this.cssClass = classes;
    const classArr = classes.split(' ');
    if (this.$el.classList.length) {
      classArr.forEach((i) => this.$el.classList.remove(i));
    }
  },
  methods: {
    onClick(e) {
      e.preventDefault();
      location.href = this.href;
    },
  },
};
</script>

<style lang="scss" scoped></style>
